import {
  AssetIdSchema,
  AssetSchema,
  ConceptIdSchema,
  ConceptSchema,
  LabelIdSchema,
  LabelSchema,
  ProjectIdSchema,
  ProjectSchema,
  RealmSchema,
  ViewIdSchema,
  ViewSchema,
  WorkspaceIdSchema,
  WorkspaceSchema,
} from "@storytell/types";
import z from "zod";

export const SyncSchema = z.object({
  assets: z.record(AssetIdSchema, AssetSchema),
  labels: z.record(LabelIdSchema, LabelSchema),
  concepts: z.record(ConceptIdSchema, ConceptSchema),
  projects: z.record(ProjectIdSchema, ProjectSchema),
  realms: z.record(z.string(), RealmSchema),
  // TODO:@andi Add Users types
  views: z.record(ViewIdSchema, ViewSchema),
  workspaces: z.record(WorkspaceIdSchema, WorkspaceSchema),
});
